module.exports = __webpack_public_path__ + "img/calendar-17.c08704b0.svg";